// ====================== LENIS ======================

const isProductPage =
  window.location.pathname.includes('/products/') ||
  document.body?.classList?.contains('template-product') ||
  Boolean(document.querySelector('product-info'));

let lenis = null;

const lockProductFrameHeight = () => {
  if (!isProductPage) return;
  const header = document.querySelector('.header');
  const headerH = header ? Math.round(header.getBoundingClientRect().height) : 0;
  const stickyTop = Math.round(window.innerWidth * 0.045);
  const frame = Math.max(320, Math.round(window.innerHeight - stickyTop));
  document.documentElement.style.setProperty('--product-frame-height', `${frame}px`);
  document.documentElement.style.setProperty('--product-sticky-top', `${stickyTop}px`);
  document.documentElement.style.setProperty('--header-height-locked', `${headerH}px`);
};

// Lock as early as possible so sticky columns don't resize mid-scroll
if (isProductPage) {
  lockProductFrameHeight();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockProductFrameHeight, { once: true });
  }
  window.addEventListener('load', lockProductFrameHeight, { once: true });
  window.addEventListener(
    'orientationchange',
    () => {
      window.setTimeout(lockProductFrameHeight, 250);
    },
    { passive: true }
  );
}

// Product page uses sticky full-viewport media columns. Lenis smooth-scroll
// makes those columns/bottom info jitter continuously — keep it off here.
if (!isProductPage && typeof Lenis === 'function') {
  lenis = new Lenis({
    smoothWheel: true,
    smoothTouch: false,
    normalizeWheel: true,
    ignore: (el) => el.classList.contains('scroll-section'),
  });

  if (typeof ScrollTrigger !== 'undefined') {
    lenis.on('scroll', ScrollTrigger.update);
  }

  if (typeof gsap !== 'undefined') {
    gsap.ticker.add((time) => {
      lenis.raf(time * 700);
    });
    gsap.ticker.lagSmoothing(0);
  }
}

// ====================== LENIS ======================

// ====================== HEADER EFFECT ======================

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  // Header class flips on product pages fight sticky product columns — leave header static
  if (isProductPage) {
    header.classList.add('is-at-top');
    header.classList.remove('is-scrolled', 'is-scroll-up');
    return;
  }

  let lastScrollY = window.scrollY || 0;
  let ticking = false;
  const deltaThreshold = 6;

  const applyHeaderState = () => {
    const currentY = window.scrollY || 0;
    const delta = currentY - lastScrollY;

    // AT TOP
    if (currentY <= 2) {
      header.classList.add('is-at-top');
      header.classList.remove('is-scrolled', 'is-scroll-up');
      lastScrollY = currentY;
      ticking = false;
      return;
    }

    // Ignore tiny Lenis / browser scroll noise
    if (Math.abs(delta) < deltaThreshold) {
      ticking = false;
      return;
    }

    // SCROLLING DOWN
    if (delta > 0 && currentY > 20) {
      header.classList.add('is-scrolled');
      header.classList.remove('is-scroll-up', 'is-at-top');
    }
    // SCROLLING UP
    else if (delta < 0) {
      header.classList.add('is-scroll-up');
      header.classList.remove('is-scrolled', 'is-at-top');
    }

    lastScrollY = currentY;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyHeaderState);
      }
    },
    { passive: true }
  );

  applyHeaderState();
});



// ====================== HEADER EFFECT ======================

// ================== CART BUTTON MOBILE =====================

document.addEventListener('DOMContentLoaded', () => {

  const getCartBtn = () =>
    document.querySelector('.header .head_main .head_right .acc_list li.bag-item .header__icon--cart');

  const triggerClick = (e) => {
    const trigger = e.target.closest('.mob-story-btn-li');
    if (!trigger) return;

    const cartBtn = getCartBtn();
    if (!cartBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // iOS-safe async click
    requestAnimationFrame(() => {
      cartBtn.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
      cartBtn.click();
    });
  };

  /* iOS-approved events */
  ['touchstart', 'pointerdown', 'click'].forEach(evt => {
    document.addEventListener(evt, triggerClick, { passive: false });
  });

});

// ================== CART BUTTON MOBILE =====================



document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
       
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});


// =============== hamburger =================

const toggleBtn = document.querySelector('.toggle-btn-d');
const mobileMenu = document.querySelector('.head_ham_container');
const menuOverlay = document.querySelector('.menu-overlay');

function closeMenu() {
  toggleBtn.classList.remove('active');
  mobileMenu.classList.remove('active-cont');
  menuOverlay?.classList.remove('active');

  document.body.style.overflow = '';
}

function menuOpen() {
  toggleBtn.classList.toggle('active');
  mobileMenu.classList.toggle('active-cont');
  menuOverlay?.classList.toggle('active');

  // Lock scroll
  if (mobileMenu.classList.contains('active-cont')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

// Open / Toggle
toggleBtn.addEventListener('click', menuOpen);

// Close when clicking overlay
menuOverlay?.addEventListener('click', closeMenu);

// Close on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMenu();
  }
});


// =============== hamburger =================




